import { render, staticRenderFns } from "./GroupChartCard.vue?vue&type=template&id=1dafa8b2"
import script from "./GroupChartCard.vue?vue&type=script&lang=js"
export * from "./GroupChartCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports